import React, {useEffect, useRef} from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import {services} from "./services";
import {helpers} from "./helpers";
import {useForm} from "react-hook-form";
import useCaptcha from 'use-offline-captcha'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {useHistory} from "react-router-dom";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    FormHelperText,
    Typography
} from "@mui/material";
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import MuiAlert from '@mui/material/Alert';
import KeyboardDoubleArrowLeft from "@mui/icons-material/KeyboardDoubleArrowLeft";
import LoadingButton from "@mui/lab/LoadingButton";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const RepairRequest = () => {
    let history = useHistory();
    const captchaRef = useRef()
    const userOpt = {
        type: 'mixed', // "mixed"(default) | "numeric" | "alpha"
        length: 5, // 4 to 8 number. default is 5
        sensitive: false, // Case sensitivity. default is false
        width: 150, // Canvas width. default is 200
        height: 52, // Canvas height. default is 50
        fontColor: '#4b4b4b',
        background: 'rgba(255, 255, 255, .2)'
    }
    const {gen, validate} = useCaptcha(captchaRef, userOpt)
    const [loading, setLoading] = React.useState(true);
    const [mobile, setMobile] = React.useState("");
    const [identificationMobile, setIdentificationMobile] = React.useState("");
    const [tel, setTel] = React.useState("");
    const [brands, setBrands] = React.useState([]);
    const [products, setProducts] = React.useState([]);
    const [serviceSymId, setServiceSymId] = React.useState([]);
    const [provinces, setProvinces] = React.useState([]);
    const [cities, setCities] = React.useState([]);
    const [regions, setRegions] = React.useState([]);
    const [parishes, setParishes] = React.useState([]);
    const [cityId, setCityId] = React.useState(0);
    const [expanded, setExpanded] = React.useState(false);
    const [openSnackBar, setOpenSnackBar] = React.useState(false);
    const [snackBarMessage, setSnackBarMessage] = React.useState("");
    const [snackBarType, setSnackBarType] = React.useState("");
    const [isTehran, setIsTehran] = React.useState(false);

    useEffect(() => {
        if (gen) gen()
    }, [gen])

    const handleRefresh = () => gen()

    useEffect(() => {
        Promise.all([services.getBrands(), services.getProvinces()])
            .then((response) => {
                // console.log(response);
                setBrands(response[0].data);
                setProvinces(response[1].data);
                setExpanded("AC1");
                setLoading(false);
            });
    }, [])

    const {register, handleSubmit, formState: {errors}, setValue} = useForm();

    const onSubmit = (data) => {
        // console.log(data);
        const isValid = validate(data.captcha)
        // console.log(isValid.toString());

        if (dataValidation(data)) {
            if (isValid) {
                setLoading(true);
                services.submitRequest(2,
                    helpers.toEnglishNumber(data.firstName),
                    helpers.toEnglishNumber(data.lastName),
                    helpers.toEnglishNumber(data.mobile),
                    helpers.toEnglishNumber(data.homeTel),
                    helpers.toEnglishNumber(data.identificationMobile),
                    data.serviceTypeId,
                    data.brandId,
                    data.productTypeId,
                    data.serviceSymId,
                    helpers.toEnglishNumber(data.descriptions),
                    data.cityId,
                    isTehran ? data.regionId : null,
                    isTehran ? data.parishId : null,
                    data.addressDesc)
                    .then((response) => {
                        // console.log(response);
                        if (response.data[0].returnValue === 1) {
                            window.scrollTo(0, 0)
                            history.push("/success");
                        } else {
                            showSnackBar("error", "خطا در ثبت درخواست!!!");
                        }
                        setLoading(false);
                    });
            } else {
                showSnackBar("error", "کد امنیتی اشتباه است");
            }
        }
    }

    const dataValidation = (data) => {
        if (helpers.toEnglishNumber(data.mobile).substring(0, 2) !== '09') {
            showSnackBar("warning", "فرمت موبایل اشتباه است");
            setExpanded("AC1");
        } else if (helpers.toEnglishNumber(data.mobile).length !== 11) {
            showSnackBar("warning", "شماره موبایل اشتباه است");
            setExpanded("AC1");
        } else if (helpers.toEnglishNumber(data.identificationMobile).length > 0 &&
            helpers.toEnglishNumber(data.identificationMobile).substring(0, 2) !== '09') {
            showSnackBar("warning", "فرمت موبایل معرف اشتباه است");
            setExpanded("AC1");
        } else if (helpers.toEnglishNumber(data.identificationMobile).length > 0 &&
            helpers.toEnglishNumber(data.identificationMobile).length !== 11) {
            showSnackBar("warning", "شماره موبایل معرف اشتباه است");
            setExpanded("AC1");
        } else {
            return true;
        }
    }

    function showSnackBar(type, message) {
        setSnackBarMessage(message);
        setSnackBarType(type);
        setOpenSnackBar(true);
    }

    const onBrandIdChange = (e) => {
        setProducts([]);
        setServiceSymId([]);
        setValue('productTypeId', null);
        setValue('serviceSymId', null);
        services.getProducts(e)
            .then((response) => {
                // console.log("setProducts:", response.data);
                setProducts(response.data);
            });
    }

    const onProductTypeIdChange = (e) => {
        services.getServiceSyms(e)
            .then((response) => {
                // console.log("setSyms:", response);
                setServiceSymId(response.data);
            });
    }

    const onMobileChange = (e) => {
        const onlyNums = e.replace(/[^0-9]/g, '');
        // if (onlyNums.length < 12) {
        setMobile(onlyNums);
        // console.log("Mobile", onlyNums);
        // }
    }

    const onIdentificationMobileChange = (e) => {
        const onlyNums = e.replace(/[^0-9]/g, '');
        // if (onlyNums.length < 12) {
        setIdentificationMobile(onlyNums);
        // console.log("Mobile", onlyNums);
        // }
    }

    const onHomeTelChange = (e) => {
        const onlyNums = e.replace(/[^0-9]/g, '');
        // if (onlyNums.length < 12) {
        setTel(onlyNums);
        // console.log("Tel", onlyNums);
        // }
    }

    const onProvinceChange = (e) => {
        setCities([]);
        setRegions([]);
        setParishes([]);
        services.getCities(e)
            .then((response) => {
                // console.log("setCities:", response);
                setCities(response.data);
            });
    }

    const onCitiesChange = (e) => {
        setRegions([]);
        setParishes([]);
        if (e === 1) {
            setIsTehran(true);
        } else {
            setIsTehran(false);
        }
        setCityId(e);
        services.getRegions(e)
            .then((response) => {
                // console.log("setRegions:", response);
                setRegions(response.data);
            });
    }

    const onRegionIdChange = (e) => {
        setParishes([]);
        services.getParishes(cityId, e)
            .then((response) => {
                // console.log("setParishes:", response);
                setParishes(response.data);
            });
    }

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackBar(false);
    };

    const action = (
        <React.Fragment>
            <Button color="secondary" size="small" onClick={handleClose}>
                UNDO
            </Button>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
            >
                <CloseIcon fontSize="small"/>
            </IconButton>
        </React.Fragment>
    );

    const handleClick = (e) => {
        // console.log(({errors}.errors));
        if (Object.keys({errors}.errors).length > 0) {
            switch (Object.keys({errors}.errors)[0]) {
                case "firstName":
                case "lastName":
                case "mobile":
                    setExpanded("AC1");
                    break;
                case "serviceTypeId":
                case "brandId":
                case "productTypeId":
                case "serviceSymId":
                    setExpanded("AC2");
                    break;
                case "province":
                case "cityId":
                    setExpanded("AC3");
                    break;
            }
            switch (Object.keys({errors}.errors)[1]) {
                case "regionId":
                case "parishId":
                    setExpanded("AC3");
                    break;
            }
        }
    }

    return (
        <div style={{padding: '0px 10px 0px 10px', marginTop: '25px', textAlign: 'right'}}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Accordion expanded={expanded === 'AC1'} onChange={handleChange('AC1')}
                           style={{backgroundColor: '#eaeaea'}}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header">
                        <Typography sx={{width: '33%', flexShrink: 0}}>
                            مرحله اول
                        </Typography>
                        <Typography sx={{color: 'text.secondary'}}>اطلاعات فردی</Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                        <Grid container spacing={1} style={{marginBottom: '3px'}}>
                            <Grid item sm={6} xs={6} md={6}>
                                <TextField
                                    inputProps={{maxLength: 20}}
                                    style={{marginTop: '6px', width: '100%'}}
                                    id="outlined-basic" label="نام" variant="outlined"
                                    {...register("firstName", {required: "نام را وارد نمایید"})}
                                    error={Boolean(errors.firstName)}
                                    helperText={errors.firstName?.message}/>
                            </Grid>
                            <Grid item sm={6} xs={6} md={6}>
                                <TextField
                                    inputProps={{maxLength: 35}}
                                    style={{marginTop: '6px', width: '100%'}}
                                    id="outlined-basic" label="نام خانوادگی" variant="outlined"
                                    {...register("lastName", {required: "نام خانوادگی را وارد نمایید"})}
                                    error={Boolean(errors.lastName)}
                                    helperText={errors.lastName?.message}/>
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} style={{marginBottom: '3px'}}>
                            <Grid item sm={6} xs={6} md={6}>
                                <TextField
                                    inputProps={{maxLength: 11}}
                                    value={helpers.toPersianNumber(mobile)}
                                    style={{marginTop: '12px', width: '100%'}}
                                    id="outlined-basic" label="شماره موبایل" variant="outlined"
                                    error={Boolean(errors.mobile)}
                                    helperText={errors.mobile?.message}
                                    {...register(
                                        "mobile",
                                        {
                                            required: "شماره موبایل را وارد نمایید",
                                            onChange: (e) => onMobileChange(helpers.toEnglishNumber(e.target.value))
                                        }
                                    )}/>
                            </Grid>
                            <Grid item sm={6} xs={6} md={6}>
                                <TextField
                                    inputProps={{maxLength: 11}}
                                    value={helpers.toPersianNumber(tel)}
                                    style={{marginTop: '12px', width: '100%'}}
                                    id="outlined-basic" label="تلفن ثابت (اختیاری)" variant="outlined"
                                    {...register(
                                        "homeTel",
                                        {
                                            required: false,
                                            onChange: (e) => onHomeTelChange(helpers.toEnglishNumber(e.target.value))
                                        }
                                    )}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} style={{paddingBottom: '20px'}}>
                            <Grid item sm={12} xs={12} md={12}>
                                <TextField
                                    inputProps={{maxLength: 11}}
                                    value={helpers.toPersianNumber(identificationMobile)}
                                    style={{marginTop: '12px', width: '100%'}}
                                    id="outlined-basic" label="شماره موبایل معرف (اختیاری)" variant="outlined"
                                    {...register(
                                        "identificationMobile",
                                        {
                                            onChange: (e) => onIdentificationMobileChange(helpers.toEnglishNumber(e.target.value))
                                        }
                                    )}/>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expanded === 'AC2'} onChange={handleChange('AC2')}
                           style={{backgroundColor: '#eaeaea'}}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header">
                        <Typography sx={{width: '33%', flexShrink: 0}}>
                            مرحله دوم
                        </Typography>
                        <Typography sx={{color: 'text.secondary'}}>اطلاعات و ایراد دستگاه</Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                        <Grid container spacing={1}>
                            <Grid item sm={6} xs={6} md={6}
                                  style={{paddingLeft: '6px', paddingRight: '0'}}>
                                <FormControl variant="outlined" sx={{m: 1, width: '100%'}}>
                                    <InputLabel id="demo-simple-select-helper-label">نوع سرویس</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-helper-label"
                                        id="demo-simple-select-helper"
                                        defaultValue=""
                                        label="نوع سرویس"
                                        {...register("serviceTypeId",
                                            {required: "نوع سرویس را انتخاب نمایید"})}
                                        error={Boolean(errors.serviceTypeId)}>
                                        <FormHelperText
                                            style={{margin: '0 10px 15px 10px', color: '#d32f2f'}}>
                                            {errors.serviceTypeId?.message}</FormHelperText>
                                        <MenuItem value={1}>نصب</MenuItem>
                                        <MenuItem value={2}>تعمیر</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item sm={6} xs={6} md={6}
                                  style={{paddingLeft: '8px', paddingRight: '0'}}>
                                <FormControl variant="outlined" sx={{m: 1, width: '100%'}}>
                                    <InputLabel id="demo-simple-select-helper-label">برند دستگاه</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-helper-label"
                                        id="demo-simple-select-helper"
                                        defaultValue=""
                                        disabled={brands.length === 0}
                                        label="برند دستگاه"
                                        {...register("brandId", {
                                            required: "برند دستگاه را انتخاب نمایید",
                                            onChange: (e) => onBrandIdChange(e.target.value)
                                        })}
                                        error={Boolean(errors.brandId)}>
                                        <FormHelperText
                                            style={{margin: '0 10px 15px 10px', color: '#d32f2f'}}>
                                            {errors.brandId?.message}</FormHelperText>
                                        {brands.length > 0 ?
                                            brands.sort((a, b) => a.title.localeCompare(b.title)).map(brand => (
                                                <MenuItem key={brand.id} value={brand.id}>{brand.title}</MenuItem>
                                            )) : false}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Grid container spacing={1}>
                            <Grid item sm={6} xs={6} md={6}
                                  style={{paddingLeft: '6px', paddingRight: '0'}}>
                                <FormControl variant="outlined" sx={{m: 1, width: '100%'}}>
                                    <InputLabel id="demo-simple-select-helper-label">نوع محصول</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-helper-label"
                                        id="demo-simple-select-helper"
                                        defaultValue=""
                                        disabled={products.length === 0}
                                        label="نوع محصول"
                                        {...register(
                                            "productTypeId",
                                            {
                                                required: "نوع محصول را انتخاب نمایید.",
                                                onChange: (e) => onProductTypeIdChange(e.target.value)
                                            }
                                        )}
                                        error={Boolean(errors.productTypeId)}>
                                        <FormHelperText
                                            style={{margin: '0 10px 15px 10px', color: '#d32f2f'}}>
                                            {errors.productTypeId?.message}</FormHelperText>
                                        {products.length > 0 ?
                                            products.sort((a, b) => a.title.localeCompare(b.title)).map(product => (
                                                <MenuItem key={product.id} value={product.id}>{product.title}</MenuItem>
                                            )) : false}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item sm={6} xs={6} md={6}
                                  style={{paddingLeft: '8px', paddingRight: '0'}}> <FormControl variant="outlined" sx={{
                                m: 1,
                                width: '100%'
                            }}>
                                <InputLabel id="demo-simple-select-helper-label">ایراد دستگاه</InputLabel>
                                <Select
                                    labelId="demo-simple-select-helper-label"
                                    id="demo-simple-select-helper"
                                    // value={age}
                                    defaultValue=""
                                    disabled={serviceSymId.length === 0}
                                    label="ایراد دستگاه"
                                    {...register("serviceSymId", {required: "ایراد دستگاه را انتخاب نمایید"})}
                                    error={Boolean(errors.serviceSymId)}>
                                    <FormHelperText
                                        style={{margin: '0 10px 15px 10px', color: '#d32f2f'}}>
                                        {errors.serviceSymId?.message}</FormHelperText>
                                    {/*<MenuItem value="">*/}
                                    {/*<em>None</em>*/}
                                    {/*</MenuItem>*/}
                                    {serviceSymId.length > 0 ?
                                        serviceSymId.filter((thing, index, self) =>
                                            index === self.findIndex((t) => (t.symCode === thing.symCode)))
                                            .sort((a, b) => a.title.localeCompare(b.title))
                                            .map(sym => (
                                                <MenuItem key={sym.id} value={sym.id}>{sym.title}</MenuItem>
                                            )) : false}
                                </Select>
                                {/*<FormHelperText>With label + helper text</FormHelperText>*/}
                            </FormControl>
                            </Grid>
                        </Grid>

                        <TextField
                            inputProps={{maxLength: 222}}
                            style={{marginTop: '10px', width: '100%'}}
                            id="outlined-multiline-static"
                            label="توضیحات (اختیاری - ترجیحا مدل دستگاه ذکر شود)"
                            multiline
                            rows={3}
                            {...register(
                                "descriptions"
                                // , {required: "توضیحات را وارد نمایید"}
                            )}
                            // error={Boolean(errors.descriptions)}
                            // helperText={errors.descriptions?.message}
                        />
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expanded === 'AC3'} onChange={handleChange('AC3')}
                           style={{backgroundColor: '#eaeaea'}}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header">
                        <Typography sx={{width: '33%', flexShrink: 0}}>
                            مرحله سوم
                        </Typography>
                        <Typography sx={{color: 'text.secondary'}}>اطلاعات محل سکونت</Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                        <Grid container spacing={1}>
                            <Grid item sm={6} xs={6} md={6}
                                  style={{paddingLeft: '6px', paddingRight: '0'}}>
                                <FormControl variant="outlined" sx={{m: 1, width: '100%'}}>
                                    <InputLabel id="demo-simple-select-helper-label">استان</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-helper-label"
                                        id="demo-simple-select-helper"
                                        defaultValue=""
                                        disabled={provinces.length === 0}
                                        label="استان"
                                        {...register(
                                            "province",
                                            {
                                                required: "استان را انتخاب نمایید",
                                                onChange: (e) => onProvinceChange(e.target.value)
                                            })}
                                        error={Boolean(errors.province)}>
                                        <FormHelperText
                                            style={{margin: '0 10px 15px 10px', color: '#d32f2f'}}>
                                            {errors.province?.message}</FormHelperText>
                                        {provinces.length > 0 ?
                                            provinces.sort((a, b) => a.title.localeCompare(b.title)).map(province => (
                                                <MenuItem key={province.id}
                                                          value={province.id}>{province.title}</MenuItem>
                                            )) : false}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item sm={6} xs={6} md={6}
                                  style={{paddingLeft: '8px', paddingRight: '0'}}>
                                <FormControl variant="outlined" sx={{m: 1, width: '100%'}}>
                                    <InputLabel id="demo-simple-select-helper-label">شهر</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-helper-label"
                                        id="demo-simple-select-helper"
                                        defaultValue=""
                                        disabled={cities.length === 0}
                                        label="شهر"
                                        {...register(
                                            "cityId",
                                            {
                                                required: "شهر را انتخاب نمایید",
                                                onChange: (e) => onCitiesChange(e.target.value)
                                            })}
                                        error={Boolean(errors.cityId)}>
                                        <FormHelperText
                                            style={{margin: '0 10px 15px 10px', color: '#d32f2f'}}>
                                            {errors.cityId?.message}</FormHelperText>
                                        {cities.length > 0 ?
                                            cities.sort((a, b) => a.title.localeCompare(b.title)).map(city => (
                                                <MenuItem key={city.id} value={city.id}>{city.title}</MenuItem>
                                            )) : false}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Grid container spacing={1}>
                            <Grid item sm={6} xs={6} md={6}
                                  style={{paddingLeft: '6px', paddingRight: '0'}}>
                                <FormControl variant="outlined" sx={{m: 1, width: '100%'}}>
                                    <InputLabel id="demo-simple-select-helper-label">منطقه</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-helper-label"
                                        id="demo-simple-select-helper"
                                        defaultValue=""
                                        disabled={!isTehran}
                                        label="منطقه"
                                        {...register(
                                            "regionId",
                                            {
                                                required: isTehran,
                                                onChange: (e) => onRegionIdChange(e.target.value)
                                            })}
                                        error={Boolean(errors.regionId)}>
                                        <FormHelperText
                                            style={{margin: '0 10px 15px 10px', color: '#d32f2f'}}>
                                            {errors.regionId?.message}</FormHelperText>
                                        {regions.length > 0 ?
                                            regions.sort((a, b) => a.title.localeCompare(b.title)).map(region => (
                                                <MenuItem key={region.id}
                                                          value={region.id}>{region.title}</MenuItem>
                                            )) : false}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item sm={6} xs={6} md={6}
                                  style={{paddingLeft: '8px', paddingRight: '0'}}>
                                <FormControl variant="outlined" sx={{m: 1, width: '100%'}}>
                                    <InputLabel id="demo-simple-select-helper-label">محله</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-helper-label"
                                        id="demo-simple-select-helper"
                                        defaultValue=""
                                        disabled={!isTehran}
                                        label="محله"
                                        {...register("parishId", {required: isTehran})}
                                        error={Boolean(errors.parishId)}>
                                        <FormHelperText
                                            style={{margin: '0 10px 15px 10px', color: '#d32f2f'}}>
                                            {errors.parishId?.message}</FormHelperText>
                                        {parishes.length > 0 ?
                                            parishes.sort((a, b) => a.title.localeCompare(b.title)).map(parish => (
                                                <MenuItem key={parish.id}
                                                          value={parish.id}>{parish.title}</MenuItem>
                                            )) : false}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <TextField
                                inputProps={{maxLength: 250}}
                                style={{marginTop: '10px', marginRight: '7px', width: '100%'}}
                                id="outlined-multiline-static"
                                label="شرح آدرس (اختیاری)"
                                multiline
                                rows={3}
                                {...register(
                                    "addressDesc")}/>
                        </Grid>
                    </AccordionDetails>
                </Accordion>

                <Grid container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      style={{marginTop: '25px'}}>

                    <Grid item>
                        <TextField
                            inputProps={{maxLength: 5}}
                            style={{width: '160px', marginLeft: '10px'}}
                            id="outlined-basic" label="کد امنیتی" variant="outlined"
                            {...register("captcha", {required: true})}
                            error={Boolean(errors.captcha)}
                            helperText="کد روبرو را وارد کنید"/>
                    </Grid>

                    <Grid item>
                        <div style={{direction: "ltr", marginTop: '2px'}} ref={captchaRef}/>
                        <Button
                            style={{
                                textAlign: "center",
                                fontSize: "12px",
                                display: "block",
                                marginRight: "auto",
                                marginLeft: "auto",
                                padding: "0px",
                                color: "#D83030"
                            }}
                            onClick={handleRefresh}>تغییر کد</Button>
                    </Grid>
                </Grid>

                {/*<Button*/}
                {/*    style={{*/}
                {/*        backgroundColor: '#D83030',*/}
                {/*        marginLeft: 'auto',*/}
                {/*        marginRight: 'auto',*/}
                {/*        marginTop: '20px',*/}
                {/*        display: 'block',*/}
                {/*        padding: '15px 40px 15px 40px'*/}
                {/*    }}*/}
                {/*    type="submit"*/}
                {/*    variant="contained">ثبت درخواست</Button>*/}

                <LoadingButton
                    style={{
                        backgroundColor: '#D83030',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        marginTop: '20px',
                        display: 'flex',
                        padding: '13px 35px 13px 35px'
                    }}
                    type="submit"
                    size="medium"
                    endIcon={<KeyboardDoubleArrowLeft/>}
                    loading={loading}
                    onClick={(e) => handleClick(e)}
                    loadingPosition="end"
                    variant="contained"
                >ثبت درخواست</LoadingButton>
            </form>

            <Snackbar
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left"
                }}
                open={openSnackBar}
                autoHideDuration={3000}
                onClose={handleClose}
                action={action}>
                <Alert onClose={handleClose} severity={snackBarType} sx={{width: '100%'}}>
                    {snackBarMessage}
                </Alert>
            </Snackbar>
        </div>
    );
}